/* Cartes des bouteilles d'un coffret (metafield custom.bundle), deux modes :
   - "classic" : cartes affichees directement.
   - "hidden"  : memes cartes, floutees sous un voile, revelables une par une
                 apres un avertissement spoiler (coffrets Vincognito / Surprise).
   Le mode vient de l'attribut data-lpb-bundle du conteneur.
   Depend de lpb-bundle-core.js (window.LpbBundle). */
(function () {
  var LPB = window.LpbBundle;
  if (!LPB) return;

  var CONSENT_KEY = 'lpb-bundle-consent';

  // Icones du kit FontAwesome deja charge par le theme (fontawesome.js)
  var ICON_HIDE = '<i class="fa-regular fa-eye-slash" aria-hidden="true"></i>';
  var ICON_SHOW = '<i class="fa-regular fa-eye" aria-hidden="true"></i>';

  function readConsent() {
    try {
      return window.sessionStorage.getItem(CONSENT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeConsent() {
    try {
      window.sessionStorage.setItem(CONSENT_KEY, '1');
    } catch (e) {
      /* navigation privee : on garde juste le consentement en memoire */
    }
  }

  function profileMarkup(profile, strings) {
    // Tous les criteres renseignes par Odoo, pas de tri arbitraire.
    var items = LPB.profileItems(profile, {
      fields: LPB.PROFILE_COMPACT,
      labels: (strings && strings.profile) || {},
      labelClass: 'lpb-body-s'
    });
    if (!items) return '';
    return '<div class="lpb-product-info__profile lpb-product-info__profile-container">' + items + '</div>';
  }

  function reviewsMarkup(bottle, strings) {
    var reviews = bottle.reviews || {};
    var rating = LPB.clean(reviews.average_rating);
    var count = parseFloat(LPB.clean(reviews.number_of_ratings));
    if (!rating || !count) return '';
    var ratings = LPB.text(strings, 'ratings');
    return (
      '<p class="lpb-body-s lpb-bundle__note">' +
      '<i class="fa-solid fa-star" aria-hidden="true"></i> ' +
      '<strong>' + LPB.esc(rating) + '</strong>/5 &middot; ' + LPB.esc(count) +
      (ratings ? ' ' + LPB.esc(ratings) : '') +
      '</p>'
    );
  }

  function labelsMarkup(bottle, labelColors) {
    var pills = LPB.labelPills(bottle.attributes, labelColors);
    var description = LPB.clean(bottle.description);
    var short = description
      ? '<strong class="lpb-product-header__short">' + LPB.esc(description) + '</strong>'
      : '';
    if (!pills && !short) return '';
    return '<div class="product-specifications__item product-specifications__item--label">' + pills + short + '</div>';
  }

  // Odoo nomme les vins "Domaine - Cuvee - Appellation - Couleur - Millesime".
  // La carte affiche deja domaine, couleur et appellation : on ne garde que la cuvee.

  function cardMarkup(bottle, index, labelColors, hidden, strings) {
    var name = LPB.shortName(bottle) || LPB.text(strings, 'surprise_bottle');
    var url = LPB.productUrl(bottle.url);
    var image = LPB.odooImage(bottle.img);
    var number = LPB.esc(LPB.text(strings, 'number_prefix')) + (index + 1);
    var bottleLabel = LPB.text(strings, 'bottle_label');

    var meta = [LPB.clean(bottle.type), LPB.clean(bottle.appellation) || LPB.clean(bottle.region)].filter(Boolean).join(' &middot; ');

    return (
      '<article class="lpb-bundle__card" data-revealed="' + (hidden ? 'false' : 'true') + '">' +
      '<div class="lpb-bundle__media">' +
      '<span class="lpb-label lpb-label-s lpb-bundle__num">' + number + '</span>' +
      (image ? '<img src="' + LPB.esc(image) + '" alt="" loading="lazy">' : '') +
      '</div>' +
      '<div class="lpb-bundle__body lpb-product-header">' +
      '<h3 class="lpb-heading-s lpb-heading-s-title lpb-bundle__name">' +
      (url ? '<a href="' + LPB.esc(url) + '">' + LPB.esc(name) + '</a>' : LPB.esc(name)) +
      '</h3>' +
      (meta ? '<p class="lpb-body-s-bold lpb-bundle__meta">' + meta + '</p>' : '') +
      LPB.domaine(bottle.winery, { nameClass: 'lpb-link-body-s', placeClass: 'lpb-body-s' }) +
      labelsMarkup(bottle, labelColors) +
      reviewsMarkup(bottle, strings) +
      profileMarkup(bottle.profile, strings) +
      '</div>' +
      (hidden
        ? '<div class="lpb-bundle__veil">' +
          '<i class="fa-regular fa-eye-slash lpb-bundle__veil-eye" aria-hidden="true"></i>' +
          '<strong class="lpb-heading-s">' + LPB.esc(bottleLabel) + ' ' + number + '</strong>' +
          '<button type="button" class="button button--s button--white" data-bundle-reveal>' +
          ICON_SHOW + '<span>' + LPB.esc(LPB.text(strings, 'reveal')) + '</span></button>' +
          '</div>' +
          '<button type="button" class="lpb-bundle__hide" data-bundle-hide aria-label="' +
          LPB.esc(LPB.text(strings, 'hide_one')) + '">' +
          ICON_HIDE +
          '</button>'
        : '') +
      '</article>'
    );
  }

  var MODAL_ID = 'lpb-bundle-modal';

  // Structure des modales du site (custom-deferred.css / lpb-modal.css) :
  // .lpb-modal > .lpb-modal-close-area + .lpb-modal-container > close / title / content / footer
  function modalMarkup(strings) {
    return (
      '<div class="lpb-modal lpb-modal--spoiler" id="' + MODAL_ID + '" role="dialog" aria-modal="true" aria-labelledby="' + MODAL_ID + '-title">' +
      '<label class="lpb-modal-close-area"></label>' +
      '<div class="lpb-modal-container">' +
      '<label class="lpb-modal-close" aria-label="' + LPB.esc(LPB.text(strings, 'close')) +
      '"><i class="fa-solid fa-xmark"></i></label>' +
      '<div class="lpb-modal-title">' +
      '<i class="fa-solid fa-triangle-exclamation lpb-modal-icon"></i>' +
      '<strong class="lpb-heading-l" id="' + MODAL_ID + '-title">' +
      LPB.esc(LPB.text(strings, 'spoiler_title')) + '</strong>' +
      '</div>' +
      '<div class="lpb-modal-content">' +
      '<p class="lpb-body-m">' + LPB.esc(LPB.text(strings, 'spoiler_text')) + '</p>' +
      '</div>' +
      '<div class="lpb-modal-footer">' +
      '<button type="button" class="button button--m button--black button--annule">' +
      LPB.esc(LPB.text(strings, 'spoiler_keep')) + '</button>' +
      '<button type="button" class="button button--m button--white" data-bundle-confirm>' +
      LPB.esc(LPB.text(strings, 'spoiler_confirm')) + '</button>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  // On passe par les helpers globaux du theme quand ils sont la, sinon meme comportement en local.
  function showModal(modal) {
    if (typeof window.openModal === 'function') {
      window.openModal(modal.id);
      return;
    }
    modal.style.display = 'flex';
    document.body.classList.add('lpb-modal-open');
  }

  function hideModal(modal) {
    modal.style.display = 'none';
    document.body.classList.remove('lpb-modal-open');
  }

  // Memes cibles de fermeture que closeModal() dans lpb-custom.js
  function isCloseTarget(target, modal) {
    if (target === modal) return true;
    return !!target.closest(
      '.lpb-modal-close, .lpb-modal-close-area, .button--annule, .fa-xmark'
    );
  }

  function init(root) {
    var data = LPB.read(root);
    var bottles = data.bottles;
    if (!bottles.length) return;

    var hidden = root.getAttribute('data-lpb-bundle') === 'hidden';
    var labelColors = data.labelColors;
    var strings = data.strings;
    var grid = root.querySelector('[data-bundle-grid]');
    var count = root.querySelector('[data-bundle-count]');
    var toggle = root.querySelector('[data-bundle-toggle]');

    grid.innerHTML = bottles
      .map(function (bottle, index) {
        return cardMarkup(bottle, index, labelColors, hidden, strings);
      })
      .join('');

    if (count) {
      var bottleWord = LPB.text(strings, bottles.length > 1 ? 'bottle_other' : 'bottle_one');
      count.textContent = bottles.length + (bottleWord ? ' ' + bottleWord : '');
    }

    // Mode "classic" : rien d'autre a brancher, les cartes sont deja visibles.
    if (!hidden) {
      if (toggle) toggle.remove();
      return;
    }

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.lpb-bundle__card'));

    if (!document.getElementById(MODAL_ID)) {
      root.insertAdjacentHTML('beforeend', modalMarkup(strings));
    }
    var modal = document.getElementById(MODAL_ID);
    var pending = null;

    function setRevealed(card, revealed) {
      card.setAttribute('data-revealed', revealed ? 'true' : 'false');
      syncToggle();
    }

    function allRevealed() {
      return cards.every(function (card) {
        return card.getAttribute('data-revealed') === 'true';
      });
    }

    function syncToggle() {
      if (!toggle) return;
      var revealed = allRevealed();
      toggle.innerHTML =
        (revealed ? ICON_HIDE : ICON_SHOW) +
        '<span>' + LPB.esc(LPB.text(strings, revealed ? 'hide_all' : 'reveal_all')) + '</span>';
      toggle.setAttribute('data-state', revealed ? 'revealed' : 'hidden');
    }

    function apply(action) {
      if (action.type === 'card') {
        setRevealed(action.card, true);
      } else {
        cards.forEach(function (card) {
          setRevealed(card, true);
        });
      }
    }

    function dismiss() {
      if (modal) hideModal(modal);
      pending = null;
    }

    function request(action) {
      if (readConsent() || !modal) {
        apply(action);
        return;
      }
      pending = action;
      showModal(modal);
      var confirmBtn = modal.querySelector('[data-bundle-confirm]');
      if (confirmBtn) confirmBtn.focus();
    }

    grid.addEventListener('click', function (event) {
      var revealBtn = event.target.closest('[data-bundle-reveal]');
      if (revealBtn) {
        request({ type: 'card', card: revealBtn.closest('.lpb-bundle__card') });
        return;
      }
      var hideBtn = event.target.closest('[data-bundle-hide]');
      if (hideBtn) {
        setRevealed(hideBtn.closest('.lpb-bundle__card'), false);
      }
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (allRevealed()) {
          cards.forEach(function (card) {
            setRevealed(card, false);
          });
          return;
        }
        request({ type: 'all' });
      });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-bundle-confirm]')) {
          writeConsent();
          if (pending) apply(pending);
          dismiss();
          return;
        }
        if (isCloseTarget(event.target, modal)) {
          dismiss();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.style.display === 'flex') dismiss();
      });
    }

    syncToggle();
  }

  function boot() {
    document.querySelectorAll('[data-lpb-bundle]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
